module.exports = __webpack_public_path__ + "static/img/IMG_00004.704aa83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf2/IMG_00004.png
// module id = 5DcI
// module chunks = 7